<template>
  <div class="intro">
    <b-container class="text-center m-auto">
      <p class="h6 text-center">Before you start, we want to ask you two important questions.</p>
      <hr />

      <b-row>
        <b-col cols="12">
          <p class="h6 font-weight-bolder text-left mb-3 text-center">
            1. What do you module to focus on?
            <small class="text-muted">Choose one module</small>
          </p>
        </b-col>
        <b-col cols="12" sm="6" v-for="(module, idx) in modules" v-bind:key="idx" class="mb-2 ">
          <input
            class="form-check-input invisible"
            type="radio"
            :id="module.id"
            name="ModuleOptions"
            v-model="picked"
            :value="module.module_order"
          />
          <label
            class="form-check-label bg-light text-blue-dark border rounded-pill w-100"
            :for="module.id"
            style="cursor:pointer"
          >
            <b-row class="align-items-center m-2">
              <b-col cols="2" sm="2" class=" p-2">
                <b-img
                  :src="module.icon"
                  :alt="module.alt"
                  class="w-75"
                ></b-img>
              </b-col>
              <b-col cols="10" sm="9" class="my-auto p-0">
                <p class="h5 m-0 text-justify">{{ module.name }}</p>
              </b-col>
            </b-row>
          </label>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    modules: Array,
  },
  data: function() {
    return {
      picked: '',
    };
  },
  methods: {
    setSelection() {
      this.$emit('stepData', { focusSelected: this.picked });
    },
  },
  watch: {
    picked() {
      this.setSelection();
    },
  },
};
</script>

<style scoped>
input[type='radio']:checked + label {
  color: #ffffff !important;
  background-color: #383c6b !important;
}
</style>
